import React from 'react';
import { Card, CardContent, CardHeader, IconButton, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { Timeline, MoreVert } from '@material-ui/icons';
import { SimovsatProgress } from '~/types';

interface ProgressCardProps {
  progress: SimovsatProgress;
}

export default function ProgressCard({ progress }: ProgressCardProps) {
  const items = [
    { label: 'Contagem', value: progress.contagem },
    { label: 'Novo', value: progress.novo },
    { label: 'Em progresso', value: progress.em_progresso },
    { label: 'Concluído', value: progress.concluido },
    { label: 'Falhou', value: progress.falhou },
  ];

  return (
    <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Timeline />
            <Typography variant='h6' style={{ fontWeight: 'bold' }}>
              ANDAMENTO
            </Typography>
          </div>
        }
        action={
          <IconButton size='small'>
            <MoreVert />
          </IconButton>
        }
        style={{ backgroundColor: '#f5f5f5', padding: '12px 16px' }}
      />
      <CardContent style={{ flex: 1, overflow: 'auto', padding: 0 }}>
        <List>
          {items.map((item, index) => (
            <ListItem key={index} divider>
              <ListItemText
                primary={item.label}
                secondary={item.value.toLocaleString('pt-BR')}
                primaryTypographyProps={{ style: { fontSize: '14px' } }}
                secondaryTypographyProps={{ style: { fontSize: '16px', fontWeight: 'bold', color: '#333' } }}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
